export default __webpack_public_path__ + "static/media/Fexocon-180-ban.b46249e9.jpg";